// material-ui
import { Box, Grid, Skeleton, Stack, Divider } from '@mui/material';

// ===========================|| SKELETON WorkFlow Menu Placeholder ||=========================== //

const MenuPlaceholder = () => {
	const menuArray = new Array(8).fill(1);
	return (
		<>
			<Box display={'flex'} sx={{ mb: 1 }}>
				<Skeleton variant="rectangular" height={40} width={40} sx={{ mr: 1 }} />
				<Stack direction="column" alignItems="flex-start" spacing={1}>
					<Skeleton variant="rectangular" height={15} width={120} />
					<Skeleton variant="rectangular" height={8} width={180} />
				</Stack>
			</Box>
			{/* divider */}
			<Divider sx={{ mt: 0.25, mb: 2 }} />
			{menuArray.map((list, index) => (
				<Stack key={index} direction="row" alignItems="center" spacing={1} sx={{ my: 2 }}>
					<Skeleton variant="rectangular" height={30} width={30} sx={{ mr: 1 }} />
					<Stack direction="column" justifyContent="center" alignItems="flex-start" spacing={1}>
						<Skeleton variant="rectangular" height={10} width={120} />
					</Stack>
				</Stack>
			))}
		</>
	);
};

export default MenuPlaceholder;
